import React, {PropTypes} from 'react';
import InjurySummaryTableRow from './InjurySummaryTableRow';

const InjurySummaryTable = ({injurySummary, form, showEmployeeInfo}) => {
  let table = [];
  if (form.formQuestions && injurySummary.id) {
    form.formQuestions.map(question => {
      let tableGroup = [];
      let rowClassName = "col-xs-12 col-sm-3";
      question.questionParts.map(questionPart => {
        if (question.questionName === 'employeeInformation') {
          rowClassName = "row-content";
        }
        if (question.questionId === "injuryAndIllnessTypes") {
          rowClassName = "col-xs-6 col-sm-3";
        }
        if (questionPart.questionPartName != 'noInjuries') {
          tableGroup.push(
            <InjurySummaryTableRow
              key={questionPart.questionPartLabel
                + injurySummary[questionPart.questionPartName]}
              rowHeader={questionPart.questionPartLabel}
              rowContent={injurySummary[questionPart.questionPartName]}
              rowClassName={rowClassName}/>
          );
        }
      });
     if (question.questionId === "injuryAndIllnessTypes") {
        table.push(
          <div key={question.questionId}
               className={"col-xs-12 " + question.questionId}>
            <h3>{question.questionName}</h3>
            <h4>Total Number Of: </h4>
            <div className="question-row-first row">
              {tableGroup[0]}{tableGroup[3]}
            </div>
            <div className="question-row-second row">
              {tableGroup[1]}{tableGroup[4]}
            </div>
            <div className="question-row-third row">
              {tableGroup[2]}{tableGroup[5]}
            </div>
          </div>
        );
      }
      else if(showEmployeeInfo && question.questionId === "employeeInformation"){
        table.push(
          <div key={question.questionId}
               className={"col-xs-12 " + question.questionId}>
            <h3>{"Employee Information"}</h3>
            <div>
              {tableGroup}
            </div>
          </div>
        );
      }
      else if(question.questionId !== "employeeInformation"){
        table.push(
          <div key={question.questionId}
               className={"col-xs-12 " + question.questionId}>
            <h3>{question.questionName}</h3>
            <h4>Total Number Of: </h4>
            <div className="row">
              {tableGroup}
            </div>
          </div>
        );
      }
    });
  }
  return (
    <div className="injury-summary-table-container">
      {table}
    </div>
  );
};

InjurySummaryTable.propTypes = {
  injurySummary: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  showEmployeeInfo: PropTypes.bool.isRequired,
};

export default InjurySummaryTable;



/** WEBPACK FOOTER **
 ** ./src/components/injurySummary/InjurySummaryTable/InjurySummaryTable.js
 **/